import { INode } from 'shared/types/tree'
import { getPresentationsInAssignables } from '../../../masters_management/utility'
import { fixAssignablePresentation, presentationHasIssues } from './utility'

export class TreePresentationsManager {
  tree: INode
  assignablePresentations: INode[] | undefined

  constructor(tree: INode) {
    this.tree = tree
  }

  get getAssignablePresentations() {
    if (!this.assignablePresentations) {
      this.assignablePresentations = getPresentationsInAssignables(this.tree)
    }
    return this.assignablePresentations
  }

  get presentationFlagsIssues() {
    return this.getAssignablePresentations.filter(presentationHasIssues)
  }

  fixAllFlagIssues() {
    return this.presentationFlagsIssues.reduce((acc, issue) => {
      return acc
        .then(() => {
          return fixAssignablePresentation(issue)
        })
        .then(() => {})
    }, Promise.resolve())
  }
}
